export const brlCurrencyFormatter = (value: number) =>
  Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(value);

export const shortBrlCurrencyFormatter = (value: number): string => {
  const formatedValue = brlCurrencyFormatter(value);
  const searchRegexp = /(R\$\s\d+)(\.[1-9]+)?.+/;
  let posfix = 'milhão';

  if (value < 1000000) {
    posfix = value < 1000 ? '' : 'mil';
    return formatedValue.replace(searchRegexp, `$1 ${posfix}`);
  }

  if (value >= 2000000) posfix = 'milhões';
  return formatedValue.replace(searchRegexp, `$1$2 ${posfix}`);
};

export const brlTextToCurrency = (value: string) => {
  const floatValue = parseFloat(value);
  return brlCurrencyFormatter(floatValue);
};
